<div class="!grid !grid-cols-1 !items-start !gap-5 lg:!grid-cols-2">
    <aside *ngIf="hasGlobalVisibility && isPendingApproval"
           class="!flex !flex-col !gap-4 !rounded-2xl !border !border-solid !border-amber-200 !bg-amber-50 !p-5 md:!flex-row md:!items-center md:!justify-between md:!p-6 lg:!col-span-2">
        <div class="!min-w-0 !max-w-xl">
            <p class="!mb-1 !text-xs !font-bold !uppercase !tracking-[0.08em] !text-amber-700">Verifica Well Done</p>
            <h3 class="!mb-1 !text-base !font-bold !text-amber-900">Società in attesa di approvazione</h3>
            <p class="!mb-0 !text-sm !leading-relaxed !text-amber-800">
                Controlla i dati e i documenti, poi approva o rifiuta. Lo stato resta visibile accanto al nome.
            </p>
            <p class="!mb-0 !mt-2 !text-sm !font-semibold !text-amber-900"
               *ngIf="canEditPaymentMethod && !company.domain">
                Per approvare la società inserisci il dominio nella sezione Impostazioni Well Done.
            </p>
        </div>
        <div class="!flex !shrink-0 !flex-wrap !gap-2">
            <button type="button"
                    class="!m-0 !inline-flex !items-center !justify-center !rounded-xl !border !border-solid !border-red-200 !bg-white !px-4 !py-2.5 !text-sm !font-semibold !text-red-700 hover:!bg-red-50 disabled:!cursor-not-allowed disabled:!opacity-50"
                    (click)="refuse.emit()"
                    [disabled]="approving">
                Rifiuta
            </button>
            <button type="button"
                    class="!m-0 !inline-flex !items-center !justify-center !rounded-xl !border-0 !bg-primary !px-4 !py-2.5 !text-sm !font-bold !text-white hover:!bg-secondary disabled:!cursor-not-allowed"
                    [ngClass]="approving ? '!opacity-80' : 'disabled:!bg-slate-200 disabled:!text-slate-400'"
                    (click)="approve.emit()"
                    [disabled]="!canApprove">
                <span *ngIf="approving" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ approving ? 'Approvazione...' : 'Approva' }}
            </button>
        </div>
    </aside>

    <app-companies-settings-header
        class="lg:!col-span-2"
        [company]="company"
        [isSuperAdmin]="isSuperAdmin"
        [provinces]="provinces"
        (logoChange)="logoChange.emit($event)"
        (copyId)="copyValue.emit($event)">
    </app-companies-settings-header>

    <app-companies-settings-company-data
        [company]="company"
        [provinces]="provinces"
        [cities]="cities"
        (provinceChange)="provinceChange.emit()">
    </app-companies-settings-company-data>

    <app-companies-settings-legal
        [company]="company"
        [provinces]="provinces"
        [legalCities]="legalCities"
        (legalProvinceChange)="legalProvinceChange.emit()">
    </app-companies-settings-legal>

    <app-companies-settings-extras
        [company]="company"
        [agents]="agents"
        [hasGlobalVisibility]="hasGlobalVisibility"
        [companyHasShop]="companyHasShop"
        [isSuperAdmin]="isSuperAdmin"
        [rulesUrl]="rulesUrl"
        [signatureUrl]="signatureUrl"
        (rulesChange)="rulesChange.emit($event)"
        (signatureChange)="signatureChange.emit($event)">
    </app-companies-settings-extras>

    <app-companies-settings-debug
        *ngIf="isSuperAdmin"
        class="lg:!col-span-2"
        [company]="company"
        [companyRaw]="companyRaw"
        [agents]="agents"
        [teamUsers]="teamUsers"
        (copyValue)="copyValue.emit($event)">
    </app-companies-settings-debug>

    <div class="!sticky !bottom-8 !z-20 !mt-4 !mb-8 !flex !justify-end !border-0 !bg-transparent !p-0 lg:!col-span-2">
        <button type="button"
                class="btn btn-primary"
                (click)="save.emit()"
                [disabled]="saving">
            <span *ngIf="saving" class="spinner-border spinner-border-sm me-2" role="status"></span>
            {{ saving ? 'Salvataggio...' : 'Salva modifiche' }}
        </button>
    </div>
</div>
